module.exports = __webpack_public_path__ + "img/chairs-sprite-1x.bb098ac3.png";